import React, { useEffect, useState } from 'react'
import UseWindowSize from '../UseWindowSize'
import Link from 'next/link'
import 'lazysizes'
import { getImageUrl } from 'src/utils/magnolia'
import { useGetMagnoliaBanner } from 'src/core/hooks/useGetMagnoliaBanner'
import SkeletonImage from '../UserInterface/Skeleton/SkeletonImage'

type ProductShowcaseProps = {
  codename: string
  btnText: string
  dataCy?: string
  mobileView?: boolean
}

const ProductShowcase = ({ codename, btnText, dataCy, mobileView = false }: ProductShowcaseProps) => {
  const { width } = UseWindowSize()
  const { dataBanner, isBannerLoading } = useGetMagnoliaBanner(codename)
  const [winSize, setWinSize] = useState(null)
  // const [href, setHref] = useState(null);
  // const href = dataBanner[0]?.slugMobile;

  useEffect(() => {
    // setHref(dynamicUrl(dataBanner[0]?.slugDesktop ?? ''))
    setWinSize(width)
  }, [])

  return (
    <div className="product-showcase-wrapper" data-cy={dataCy}>
      <div className={`product-showcase-container ${mobileView ? 'product-showcase-container--mobile' : ' '}`}>
        {isBannerLoading ? (
          <SkeletonImage height={winSize > 600 ? '360px' : '200px'} className="skeleton-banner" />
        ) : (
          <Link href={'/go-ers'} as={dataBanner[0]?.slugMobile} legacyBehavior>
            <a>
              <div style={{ borderRadius: '16px' }}>
                <SkeletonImage
                  style={{ boxShadow: '0 3px 10px 0 #4b4a4a' }}
                  src={getImageUrl(dataBanner[0]?.bannerDesktop)}
                  alt={dataBanner[0]?.slugDesktop}
                />
                {!mobileView && <span className="ajukan-showcase-button">{btnText}</span>}
              </div>
            </a>
          </Link>
        )}
      </div>
      <style jsx>{`
        .product-showcase-wrapper {
          display: flex;
          justify-content: center;
          background-color: var(--color-white);
        }
        .product-showcase-container {
          max-width: 940px;
          width: 100%;
          border-radius: 16px;
          margin: 34px 16px 34px 0;
          position: relative;
        }
        .product-showcase-container img {
          width: 100%;
          height: 100%;
          border-radius: 16px;
          position: relative;
        }
        .ajukan-showcase-button {
          display: flex;
          justify-content: center;
          align-items: center;
          align-self: center;
          border-radius: 6px;
          color: var(--color-red);
          background-color: var(--color-white);
          height: 32px;
          width: 125px;
          margin: 32px;
          font-weight: 600;
          font-size: 12px;
          position: absolute;
          z-index: 10;
          bottom: 0;
          right: 0;
        }
        .ajukan-showcase-button:hover {
          cursor: pointer;
        }
        .product-showcase-container--mobile {
          height: auto;
          width: 90%;
        }
        @media only screen and (max-width: 600px) {
          .product-showcase-container {
            margin: 34px 10px 34px 0;
          }
          .product-showcase-container,
          .product-showcase-container--mobile {
            height: auto;
            width: 90%;
          }
          .ajukan-showcase-button {
            margin: 12px;
            font-size: 7px;
            width: 85px;
            height: 20px;
          }
        }
      `}</style>
    </div>
  )
}

export default ProductShowcase
